<script setup lang="ts">
import { faCalendar, faUser } from '@fortawesome/pro-regular-svg-icons';
import RouteInfo from '@components/util/trip/TripCardSegment/RouteInfo.vue';
import type TripPackage from '@itinerary/trip/TripPackage';

const itineraryStore = useItineraryStore();
const autoReserveStore = useAutoReserveStore();
const { infoDate } = classToRefs(autoReserveStore);
const currentModule = useCurrentItineraryModule();
const formStore = useFormStore();
const segment = computed(() => {
    const [selectedAutoReservePackage] = autoReserveStore.selectedPackages;
    if (selectedAutoReservePackage) {
        return (selectedAutoReservePackage as TripPackage).segments?.[0];
    }
    return (
        (formStore.emptyPackage as TripPackage) ||
        (itineraryStore.emptyPackage as TripPackage) ||
        (currentModule.value.autoReservableList as TripPackage[])?.[0]
    )?.segments?.[0];
});
const trip = computed(() => segment.value?.digest?.[0]);
const countSummary = computed(
    () =>
        `${
            formStore.adultCount + formStore.childCount + formStore.infantCount
        } مسافر`
);
</script>
<template>
    <div v-if="segment" class="auto-reserve-card-info-root">
        <div class="route-info">
            <mr-typography size="display4" weight="700">
                {{ trip?.originCityName }}
            </mr-typography>
            <RouteInfo :segment full-width class="flex" />
            <mr-typography size="display4" weight="700">
                {{ trip?.destinationCityName }}
            </mr-typography>
        </div>
        <div class="trip-summary">
            <div class="info">
                <mr-icon :icon="faCalendar" color="var(--cool-gray-500)" />
                <mr-typography weight="500" color="var(--cool-gray-500)">
                    {{ infoDate }}
                </mr-typography>
            </div>
            <div class="info">
                <mr-icon :icon="faUser" color="var(--cool-gray-500)" />
                <mr-typography weight="500" color="var(--cool-gray-500)">
                    {{ countSummary }}
                </mr-typography>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.auto-reserve-card-info-root {
    padding: 12px;
    background: white;
    @include shadow;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 8px;
    .route-info {
        display: flex;
        align-items: center;
    }
    .trip-summary {
        display: flex;
        justify-content: space-between;
        .info {
            display: flex;
            align-items: center;
            gap: 4px;
        }
    }
}
</style>
